export default __webpack_public_path__ + "static/media/12.983ace06.png";